// Free-tool registry. Each entry becomes a prerendered route at /tools/<slug>
// (see App.tsx) and a card on the /tools hub. The build scripts read this file
// by regex — keep each entry's `slug`, `title` and `description` on the shape
// shown below, in that order, as plain string literals.
//
// `updated` is the ISO date the tool (or its data) was last reviewed; ToolPage
// puts it in the WebApplication JSON-LD as dateModified.

import type { ComponentType } from 'react';

export interface ToolEntry {
  slug: string;
  title: string;
  description: string;
  /** ISO date of the last review; JSON-LD dateModified. */
  updated?: string;
  /** Lazy import so each tool ships as its own chunk. */
  component: () => Promise<{ default: ComponentType }>;
}

export const tools: ToolEntry[] = [
  {
    slug: 'oracle-fusion-middleware-support-dates',
    title: 'Oracle Fusion Middleware support dates, 12c to 14c',
    description:
      'Published support windows for applicable Oracle middleware releases, with product boundaries, policy dates and links to the current Oracle sources.',
    updated: '2026-09-16',
    component: () => import('../pages/tools/OracleFusionMiddlewareSupportDates'),
  },
  {
    slug: 'webcenter-decision-guide',
    title: 'WebCenter 12c decision guide: the four forward paths',
    description:
      'Check your current estate, funding and missing information before comparing WebCenter paths. Unknown answers produce discovery questions, not assumptions.',
    updated: '2026-09-16',
    component: () => import('../pages/tools/WebCenterDecisionGuide'),
  },
  {
    slug: 'webcenter-tco-calculator',
    title: 'WebCenter cost-of-ownership scenario planner',
    description:
      'Compare dated WebCenter cost scenarios with a current-state baseline, editable assumptions, transition costs, sensitivity ranges and an exportable record.',
    updated: '2026-09-16',
    component: () => import('../pages/tools/WebCenterTcoCalculator'),
  },
  {
    slug: 'wcc-component-inventory',
    title: 'WebCenter Content component inventory',
    description:
      'Paste a WebCenter Content component listing and get it sorted into Oracle-shipped, Oracle-family, custom and unrecognized, with the notes that matter for 14c.',
    updated: '2026-09-16',
    component: () => import('../pages/tools/WccComponentInventory'),
  },
  {
    slug: 'webcenter-content-inspector',
    title: 'WebCenter discovery readiness check',
    description:
      'Review six areas of WebCenter documentation, identify evidence gaps and download your self-assessment. No environment connection or inspection is performed.',
    updated: '2026-09-16',
    component: () => import('../pages/tools/WebCenterContentInspector'),
  },
  {
    slug: 'wfr-template-analyzer',
    title: 'Forms Recognition template library analyzer',
    description:
      'Review WFR project inventory using mapped CSV columns, a parsing preview, author distribution and date checks. Validate findings against processing results.',
    updated: '2026-09-16',
    component: () => import('../pages/tools/WfrTemplateAnalyzer'),
  },
];
